
const digest = '54dbfad8134bfdba49752636a9d7349590973a817394561cd625771c1abb339c';
const classes = {"wrapper":"_wrapper_miqxj_1","options":"_options_miqxj_9","leftPart":"_leftPart_miqxj_20","filter":"_filter_miqxj_26","resetFilterButton":"_resetFilterButton_miqxj_32","title":"_title_miqxj_35","list":"_list_miqxj_42","collapseContent":"_collapseContent_miqxj_69","row":"_row_miqxj_77"};
const css = `._wrapper_miqxj_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
  overflow-y: hidden;
}
._wrapper_miqxj_1 ._options_miqxj_9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}
._wrapper_miqxj_1 ._options_miqxj_9 ._leftPart_miqxj_20 {
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: center;
}
._wrapper_miqxj_1 ._options_miqxj_9 ._leftPart_miqxj_20 ._filter_miqxj_26 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
._wrapper_miqxj_1 ._options_miqxj_9 ._leftPart_miqxj_20 ._filter_miqxj_26 ._resetFilterButton_miqxj_32 {
  min-width: fit-content;
}
._wrapper_miqxj_1 ._options_miqxj_9 ._leftPart_miqxj_20 ._title_miqxj_35 {
  font-size: 12px;
  color: #000000;
}
._wrapper_miqxj_1 ._options_miqxj_9 ._leftPart_miqxj_20 ._title_miqxj_35 span {
  font-weight: 500;
}
._wrapper_miqxj_1 ._list_miqxj_42 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_miqxj_1 ._list_miqxj_42::-webkit-scrollbar {
  display: block;
}
._wrapper_miqxj_1 ._list_miqxj_42::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_miqxj_1 ._list_miqxj_42::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_miqxj_1 ._list_miqxj_42::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_miqxj_1 ._list_miqxj_42::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_miqxj_1 ._list_miqxj_42 ._collapseContent_miqxj_69 {
  background-color: #ffffff;
  border-left: 1px solid #eaedf3;
  overflow-x: hidden;
}
._wrapper_miqxj_1 ._list_miqxj_42 ._collapseContent_miqxj_69:last-of-type {
  border-bottom: 1px solid #eaedf3;
}
._wrapper_miqxj_1 ._list_miqxj_42 ._collapseContent_miqxj_69 ._row_miqxj_77 {
  margin: 0 -7px;
  padding: 6px 0;
  overflow-x: hidden;
  display: flex;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  